import { concat, defer, Observable, of } from 'rxjs';
import { FormArray, FormControl, FormGroup } from '@angular/forms';

export function waitPromises(requests: Array<Promise<any>>) {
  return new Observable(observer => {
    Promise.all(requests).then(() => {
      observer.next();
      observer.complete();
    });
  });
}

export function fromFormControlValue<T>(
  control: FormControl<T>,
): Observable<T> {
  return concat(
    defer(() => of(control.value)),
    control.valueChanges,
  );
}

export function fromFormGroupValue<T extends FormGroup>(
  group: T,
): Observable<ReturnType<T['getRawValue']>> {
  return concat(
    defer(() => of(group.getRawValue())),
    group.valueChanges,
  );
}

export function fromFormArrayValue<T extends FormArray>(
  control: FormArray,
): Observable<ReturnType<T['getRawValue']>> {
  return concat(
    defer(() => of(control.value)),
    control.valueChanges,
  );
}
